import React, { useEffect } from "react";
import * as sweetalert from "sweetalert";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import Controls from "../global/controls/Controls";
import { useForm, Form } from "./useForm";
import packageJson from "../../../../package.json";
import { useState } from "react";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Viewprovider() {
  const navigate = useNavigate();
  const location = useLocation();
  const [Countries, setCountries] = useState("");
  const [ErrorLocation, setErrorLocation] = useState(false);
  const [loading, setLoading] = useState(false);

  const { id } = useParams();
  const initialFValues = {
    user_name: "",
    gsm: "",
    OwnerProvider: "",
    password: "",
    location: "",
    national_id: "",
  };
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/country/1/cities`, {
        withCredentials: true,
      })
      .then((res) => {
        setCountries(res.data.data);
      });
  }, []);
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };

    if ("user_name" in fieldValues)
      temp.user_name = fieldValues.user_name ? "" : "هذا الحقل  مطلوب";
    if ("OwnerProvider" in fieldValues)
      temp.OwnerProvider = fieldValues.OwnerProvider ? "" : "هذا الحقل  مطلوب";
    if ("location" in fieldValues)
      temp.location = fieldValues.location ? "" : "هذا الحقل مطلوب";
    if ("gsm" in fieldValues) {
      if (fieldValues.gsm === "") {
        temp.gsm = "هذا الحقل مطلوب";
      } else if (!/^[0-9]+$/.test(fieldValues.gsm)) {
        temp.gsm = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else {
        temp.gsm = "";
      }
    }
    if ("national_id" in fieldValues) {
      if (fieldValues.national_id == "") {
        temp.national_id = " الرقم الوطني مطلوب";
      } else if (!/[0-9]/.test(fieldValues.national_id)) {
        temp.national_id = "يجب أن يكون الرقم الوطني أرقام";
      } 
      else if (fieldValues.national_id.length !== 11) {
        temp.national_id = "يجب أن يكون رقم الوطني 11 رقمًا";
      }
      else {
        temp.national_id = "";
      }
    }
    
    if ("password" in fieldValues) {
      if (fieldValues.password == "") {
        temp.password = "كلمة السر مطلوبة";
      } else if (fieldValues.password.length < 8) {
        temp.password = "يجب ان تكون ثماني محارف";
      } else {
        temp.password = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const validate2 = (fieldValues = loginInput) => {
    let temp = { ...errors };
    if ("gsm" in fieldValues) {
      if (fieldValues.gsm !== "" && !/^[0-9]+$/.test(fieldValues.gsm)) {
        temp.gsm = "يجب أن يكون رقم الموبايل أرقام فقط";
      }  else {
        temp.gsm = "";
      }
    }

    setErrors({
      ...temp,
    });
    if (fieldValues == loginInput)
      return Object.values(temp).every((x) => x == "");
  };
  const {
    loginInput,
    setLogin,
    errors,
    setErrors,
    handleInputChange,
    addForm,
  } = useForm(initialFValues, true, validate);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/provider/${id}`, {
        withCredentials: true,
      })
      .then((res) => {
        setLogin({
          user_name: res.data.data.user_name,
          gsm: res.data.data.gsm,
          OwnerProvider: res.data.data.OwnerProvider,
          national_id: res.data.data.national_id,
          location: res.data.data.location,
          password: res.data.data.password,
        });
      })
      .catch((err) => {});
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
        setLoading(true);
        const bodyFormData = new FormData();
        bodyFormData.append("user_name", loginInput.user_name);
        bodyFormData.append("gsm", loginInput.gsm);
        bodyFormData.append("password", loginInput.password);
        bodyFormData.append("OwnerProvider", loginInput.OwnerProvider);
        bodyFormData.append("location", loginInput.location);
        bodyFormData.append("national_id", loginInput.national_id);

        axios
          .post(`${BaseUrl}/api/updateProvider/${id}`, bodyFormData, {
            withCredentials: true,
          })
          .then((res) => {
            setLoading(false);
            if (res.data.status === true) {
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              }).then(() => {
                navigate("/providers");
              });
              
            } else {
              setLoading(false);
              sweetalert(res.data.msg, {
                className: "alert-div",
                button: {
                  text: "تم",
                },
              });
            }
          });
      }
    
  };
  useEffect(() => {
    validate2(loginInput);
  }, [loginInput]);

  useEffect(() => {
    if(loading === true && !validate()) {
    setTimeout(() => {
      // After the timeout, reset the loading state
      setLoading(false);
      // Your other logic here
    }, 2000); // Adjust the timeout duration as needed
    }
  }, [loading]);
  return (
    <div className="main-div">
      {location.state.mod === "View" ? (
        <h3 className="titlepage">استعراض نقطة البيع</h3>
      ) : (
        <h3 className="titlepage">تعديل نقطة البيع</h3>
      )}

      <Form
        className="form-group new-design"
        method="post"
        enctype="multipart/form-data"
        onSubmit={handleSubmit}
      >
        <Grid container maxWidth="sm" spacing={4}>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label=" اسم المستخدم"
              name="user_name"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.user_name}
              className="form-control"
              error={errors.user_name}
              type="text"
            />
          </Grid>

          <Grid item md={6} xs={12}>
            <Controls.Input
              label="رقم الموبايل"
              name="gsm"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.gsm}
              className="form-control"
              error={errors.gsm}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="مالك نقطة البيع"
              name="OwnerProvider"
              variant="outlined"
              fullWidth
              value={loginInput.OwnerProvider}
              onChange={handleInputChange}
              className="form-control"
              error={errors.OwnerProvider}
             
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="الرقم الوطني"
              name="national_id"
              variant="outlined"
              fullWidth
              required
              disabled={location.state.mod === "View" ? true : false}
              onChange={handleInputChange}
              value={loginInput.national_id}
              className="form-control"
              error={errors.national_id}
              type="number"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Controls.Input
              label="كلمة المرور"
              name="password"
              variant="outlined"
              fullWidth
              required
              onChange={handleInputChange}
              value={loginInput.password}
              className="form-control"
              error={errors.password}
              disabled={location.state.mod === "View" ? true : false}
              type="text"
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <div class="select">
              <select
                required
                onChange={handleInputChange}
                name="location"
                class="select-text"
                value={loginInput.location}
                disabled={location.state.mod === "View" ? true : false}
              >
                <option selected disabled className="title-option">
                  المنطقة
                </option>
                {Countries &&
                  Countries.map((opts) => (
                    <option value={opts.name_ar}>{opts.name_ar}</option>
                  ))}
              </select>
              <span class="select-highlight"></span>
              <span class="select-bar"></span>
              <label class="select-label">المحافظة</label>
            </div>
            {loginInput.location ==''?(
            <div style={{ color: "red", fontSize: "10px" ,textAlign:'end'}}>
              {errors.location}
            </div>
            ):(
              <></>
            )}
          </Grid>
        </Grid>
        {location.state.mod === "View" ? (
          <></>
        ) : (
          <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          {loading === true ? (
            <Controls.Button
              text=<div class="spinner center">
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
                <div class="spinner-blade"></div>
              </div>
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          ) : (
            <Controls.Button
              type="submit"
              text="تعديل"
              onClick={addForm}
              variant="contained"
              className="btn-submit"
            ></Controls.Button>
          )}
          </Grid>
        )}
      </Form>
    </div>
  );
}
